import { Link } from 'react-router-dom';

import { buttonVariants } from '@impact/ui';

export const ErrorFallback = ({ error }: { error: any }) => {
  console.error(error);
  return (
    <div
      id="error-page"
      className="flex justify-center items-center flex-col h-screen gap-16"
    >
      <h1 className="text-4xl font-bold">Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i className="text-gray-500">{error.statusText || error.message}</i>
      </p>
      <Link className={buttonVariants({ variant: 'outline' })} to="/">
        Return to home
      </Link>
    </div>
  );
};
